import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import styles from '../styles.module.scss';

const PlayButton = ({ isPlaying, play, rewindForward, rewindBack }) => {
	const [isHovered, setIsHovered] = useState(false);

	const handleChange = (event) => {
		switch (event.code) {
			case 'ArrowLeft':
				return rewindBack(event);
			case 'ArrowRight':
				return rewindForward(event);
			default:
				return play;
		}
	};

	const changeHoverStatus = (buttonType) => {
		switch (buttonType) {
			case 'play':
				return isHovered
					? 'audio-playButton-hover'
					: 'audio-playButton-default';
			case 'pause':
				return isHovered
					? 'audio-pauseButton-hover'
					: 'audio-pauseButton-default';
			default:
				return '';
		}
	};

	const playTrack = (event) => {
		play(event);
		setIsHovered(false);
	};

	return (
		<button
			type="button"
			onClick={playTrack}
			onKeyDown={handleChange}
			className={styles.playPause}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			{isPlaying ? (
				<Icon icon={changeHoverStatus('pause')} />
			) : (
				<Icon icon={changeHoverStatus('play')} />
			)}
		</button>
	);
};

PlayButton.propTypes = {
	isPlaying: PropTypes.bool.isRequired,
	play: PropTypes.func.isRequired,
	rewindForward: PropTypes.func.isRequired,
	rewindBack: PropTypes.func.isRequired
};

export default PlayButton;
